export default __webpack_public_path__ + "static/media/boy_vector.6098b6de.jpg";